@if (cloneFinalised$ | async) {
  <eco-job-status-placeholder title="Tenant Successfully Cloned!"
    subtitle="Tenant {{ (newTenant$ | async)?.Value }} was successfully cloned from Tenant {{ (cloneFromTenant$ | async)?.Value }}.">
    <div class="button-container">
      <button mat-raised-button color="accent" (click)="redirectToClonedTenant()">Go to cloned
      tenant</button>
      <button mat-raised-button color="accent" (click)="cloneAnotherTenant()">Clone another
      tenant</button>
    </div>
  </eco-job-status-placeholder>
} @else {
  <form #copyConfigForm="ngForm">
    <div class="row selectors-container">
      <div class="tenant">
        <div>
          <span class="title">Clone From:</span>
          <mat-select name="cloneFromTenant" placeholder="Select source tenant" class="mat-primary"
            [(ngModel)]="cloneFromTenantValue" (selectionChange)="changeCloneFrom()">
            @for (tenant of getTenantList(); track tenant) {
              <mat-option [value]="tenant.Value">
                {{ tenant.Value }}
              </mat-option>
            }
          </mat-select>
        </div>
        <div class="environment">
          <span class="title">Environment:</span>
          {{ (cloneFromEnvironment$ | async)?.EnvironmentName }}
        </div>
        <div class="clone-records">
          <mat-checkbox name="CloneRecords" [(ngModel)]="cloneRecords">
            Clone module records (for large tenants, this can take a very long time)
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="row">
      <h3>New Tenant</h3>
      <app-new-tenant-form (formSubmitted)="openCloneConfirmationPopup($event)" [hasEnvironmentField]="true"
      [actionName]="'Clone'"></app-new-tenant-form>
    </div>
  </form>
}

